import React from 'react';
import {Button,TextField,Box} from '@mui/material';
import Typography from '@mui/material/Typography';
import ETVTable from "../tools/ETVTable";
import ETVPage from "../tools/ETVPage";
import ETVPopup from "../tools/ETVPopup";
import ETVActionButton from "../tools/ETVActionButton";
import ETVMessagePopup from "../tools/ETVMessagePopup";
import IconButton from '@mui/material/IconButton';
import UploadFileIcon from '@mui/icons-material/CloudUpload';
import FileUploadAdmin from './FileUploadAdmin';
import * as ETVConstants from '../ETVConstants';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';
import ScreenShotIcon from '@mui/icons-material/AddToHomeScreen';
import StorageIcon from '@mui/icons-material/Storage';
import { SettingsRemoteOutlined } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import { buildingApi } from '../building/BuildingApi';

class RemoteDeviceMgmt extends React.Component {
	screenListRequestInFlight = false;
	webPlayerListRequestInFlight = false;

	constructor(props) {
      super(props);
			this.getRestartReplyStatus = this.getRestartReplyStatus.bind(this);
			this.getScreenShotReplyStatus = this.getScreenShotReplyStatus.bind(this);
			this.getLogReplyStatus = this.getLogReplyStatus.bind(this);
    }

    state = {
      	items:[],
		webPlayers:[],
		webPlayersLoaded:false,
		groups:[],
	    isLoaded: false,
      	selected_device_id: undefined,
		selected_group_id: undefined,
		window: undefined,
		info_type:undefined,
		spinning:false,
		info_message: undefined,
		info_title: undefined,
		message_id: undefined,
		msg_count: 0,
		screenshot_url: undefined,
		screen_ratio: 16/9,
		is_landscape: true,
		aborted: false,
		info_message_spinning:false,
    }

	componentDidUpdate() {
      if(!this.state.isLoaded) {
        this.loadItems();
      }
	}

    componentDidMount() {
      this.loadItems();
    }

	loadItems() {
		if(this.screenListRequestInFlight) return;
		this.screenListRequestInFlight = true;
		this.loadWebPlayers();
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/device_mgmt?action=list&owner_id="+this.props.user_id;
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
        .then(
		  (result) => {
			var groups = ETVConstants.filterOutEmptyGroups(result.groups);
			//var sorted = this.filterOutScreensInGroups(result.list,groups);
			var sorted = result.list || [];
			sorted.sort(ETVConstants.compareDevice);
            this.setState({
              	items: sorted,
              	isLoaded: true,
				groups: groups,
            });
          },
          (error) => {
            this.setState({
              items:[],
			  isLoaded: true,
              error
            });
          }
        )
		.finally(()=>{this.screenListRequestInFlight=false;});
	}

	loadWebPlayers = () => {
		if(ETVConstants.ON_PREMISE_VERSION) {
			if(!this.state.webPlayersLoaded) this.setState({webPlayers:[],webPlayersLoaded:true});
			return;
		}
		if(this.webPlayerListRequestInFlight) return;
		this.webPlayerListRequestInFlight = true;
		buildingApi('admin_list_web_players', {query:{owner_user_id:this.props.user_id}})
			.then((result)=>{
				const webPlayers = result.list || [];
				webPlayers.sort(ETVConstants.compareDevice);
				this.setState({webPlayers,webPlayersLoaded:true});
			})
			.catch((error)=>this.setState({webPlayers:[],webPlayersLoaded:true,webPlayerError:error}))
			.finally(()=>{this.webPlayerListRequestInFlight=false;});
	}

    showWindow(divID, show) {
      	this.setState({show_overlay:show});
      	show?this.setState({window:divID}):this.setState({window:''});
    }

	getItem( deviceID) {
		const allItems = [...this.state.items,...this.state.webPlayers];
		for(var i=0; i<allItems.length; i++) {
			if(allItems[i].id===deviceID) {
				return allItems[i];
        	}
      	}
		return undefined;
	}

	isWebPlayer = (deviceOrID) => {
		const device = typeof deviceOrID==='string' ? this.getItem(deviceOrID) : deviceOrID;
		return Number(device?.device_type)===3;
	}

	disableRemoteActionsForWebPlayers = (columns) => {
		const remoteActionTitles = new Set([
			ETVConstants.trans('message_on'), ETVConstants.trans('message_off'),
			ETVConstants.trans('reboot'), ETVConstants.trans('restart_app'),
			ETVConstants.trans('screen_shot'), ETVConstants.trans('file_upload'),
			ETVConstants.trans('get_logs'),
		]);
		return columns.map((column) => {
			if(column.field==='device_name') {
				return {...column,render:(rowData)=><Box sx={{minWidth:200}}>
					<Typography variant="body2">{rowData.device_name}</Typography>
					{this.isWebPlayer(rowData) && <Typography variant="caption" color="primary">Web Player</Typography>}
				</Box>};
			}
			if(!remoteActionTitles.has(column.title) || typeof column.render!=='function') return column;
			const originalRender = column.render;
			return {...column,render:(rowData) => {
				const rendered = originalRender(rowData);
				if(!this.isWebPlayer(rowData) || !React.isValidElement(rendered)) return rendered;
				return <Tooltip title="Remote commands are not available for Web Players"><span>{React.cloneElement(rendered,{disabled:true,onClick:undefined,color:'default'})}</span></Tooltip>;
			}};
		});
	}

	showInfoMessagePrivate(infoType,title,msg,isSpinning) {
		this.setState({window:'message_div',info_type:infoType,info_title:title,info_message:msg,spinning:isSpinning});
	}

  	closeInfoMessage() {
	 	this.setState({window:'',info_type:'',info_title:'',info_message:undefined,spinning:false, aborted:true});
  	}	

	showErrorMessage( title, msg) {
		this.showInfoMessagePrivate("error",title,msg,false);
	}

	showSuccessMessage( title, msg) {
		this.showInfoMessagePrivate("success",title,msg,false);
	}

	showInfoMessage( title, msg) {
		this.showInfoMessagePrivate("info",title,msg,false);
	}

	showInfoMessageSpinning( title, msg) {
		this.showInfoMessagePrivate("info",title,msg,true);
	}

	extractMediaUrlFromOldVersion(txt) {
		if(txt.indexOf("https:")>=0) {
			var temp = txt.substring(txt.indexOf("https:"));
			temp = temp.substring(0,temp.indexOf("\\"));
			//console.log("11temp="+temp);
			return temp;
		}
		return null;
	}

	getScreenShotReplyStatus() {
		//console.log("reply status");
		var msgCnt = this.state.msg_count;
		if(msgCnt>10 || this.state.aborted) {
			if(msgCnt>10) this.showErrorMessage(ETVConstants.trans("error"),ETVConstants.trans("could_not_reach_device"));
			return;
		}
		this.showInfoMessageSpinning(ETVConstants.trans("screen"),ETVConstants.trans("waiting_for_reply"));
		this.setState({msg_count:msgCnt+1});
		var url = ETVConstants.getServerBase()+'/firebase?action=reply_message_status&message_id='+this.state.message_id;
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then(
			(result) => {
				var replyMSG = result["reply_message"];
				if(!replyMSG) {
					// message not yet available
					this.setState({msg_count:msgCnt+1});
					setTimeout(()=>this.getScreenShotReplyStatus(), 1000);
					return;
				}

				// new version of app (from 56)
				var url = replyMSG["media_url"];
				if(url) {
					this.setState({screenshot_url:url});
					this.showWindow('screenshot_div',true);
					return;
				}

				// old version, no proper json...
				var obj0 = this.extractMediaUrlFromOldVersion(JSON.stringify(replyMSG));
				if(obj0) {
					this.setState({screenshot_url:obj0});
					this.showWindow('screenshot_div',true);
					return;
				}

				// should not happen, but otherwise generates a timeout
				this.setState({msg_count:msgCnt+1});
				setTimeout(()=>this.getScreenShotReplyStatus(), 1000);
			},
			(error) => {
			}
		)
	}

	getRestartReplyStatus() {
		var msgCnt = this.state.msg_count;
		if(msgCnt>10 || this.state.aborted) {
			if (msgCnt>10) this.showInfoMessage(ETVConstants.trans("error"),ETVConstants.trans("could_not_reach_device"));
			return;
		}
		this.showInfoMessageSpinning(ETVConstants.trans("restart"),ETVConstants.trans("waiting_for_reply"),true);
		this.setState({msg_count:msgCnt+1});
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		//var url = ETVConstants.getServerBase()+'/firebase?action=reply_message_status&message_id=8177f31a-95df-4036-a126-43caf4c36b03';
		var url = ETVConstants.getServerBase()+'/firebase?action=reply_message_status&message_id='+this.state.message_id;
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then(
			(result) => {
				if(result.hasOwnProperty("reply_message")) {
					var replyMsg = result["reply_message"];
					var isStopped = replyMsg.stopped;
					if(isStopped) {
						this.showSuccessMessage(ETVConstants.trans("stopped"),ETVConstants.trans("application_is_stopped"));
						return;
					}
					var isRestarting = replyMsg.restarting;
					if(isRestarting) {
						this.showSuccessMessage(ETVConstants.trans("restart"),ETVConstants.trans("device_is_restarting"));
					}else{
						setTimeout(()=>this.getRestartReplyStatus(), 1000);
						this.setState({msg_count:msgCnt+1});
					}
				}else{
					this.setState({msg_count:msgCnt+1});
					setTimeout(()=>this.getRestartReplyStatus(), 1000);
				}
			},
			(error) => {
			}
		)
	}

	getLogReplyStatus() {
		//console.log("log reply status");
		var msgCnt = this.state.msg_count;
		if(msgCnt>10 || this.state.aborted) {
			if(msgCnt>10) this.showErrorMessage(ETVConstants.trans("error"),ETVConstants.trans("could_not_reach_device"));
			return;
		}
		this.showInfoMessageSpinning(ETVConstants.trans("logs"),ETVConstants.trans("waiting_for_reply"));
		this.setState({msg_count:msgCnt+1});
		var url = ETVConstants.getServerBase()+'/firebase?action=reply_message_status&message_id='+this.state.message_id;
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then(
			(result) => {
				var replyMSG = result["reply_message"];
				if(!replyMSG) {
					// message not yet available
					this.setState({msg_count:msgCnt+1});
					setTimeout(()=>this.getLogReplyStatus(), 1000);
					return;
				}
				if(replyMSG["device_id"]) {
					var msg11 = "https://storage.googleapis.com/hotel-screen.appspot.com/"+replyMSG["device_id"]+"/log/general_0.txt";
					this.showSuccessMessage("logs",msg11);
					this.setState({message_id:'',msg_count:0});
				}
			},
			(error) => {
			}
		)
	}

	screenShot(deviceID, ratio, isLandscape) {
		this.setState({screen_ratio:ratio, is_landscape:isLandscape, aborted:false});
		this.showInfoMessageSpinning(ETVConstants.trans("screen_shot"),ETVConstants.trans("sending_screen_shot_request"));
		const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({action: 'send_message', device_id:deviceID, fb_action:'screenshot' })
		};
		fetch(ETVConstants.getServerBase()+'/firebase', requestOptions)
		.then(res => res.json())
		.then(
			(result) => {
					if(result['result']) {
						this.showInfoMessageSpinning(ETVConstants.trans("screen"),ETVConstants.trans("sending_screen_shot_request"));
						this.setState({message_id:result.data.message_id, msg_count:0});
						if(!this.state.aborted) setTimeout(()=>this.getScreenShotReplyStatus(), 1000);
					}else{
						this.showErrorMessage(ETVConstants.trans("error"),result.reason);
					}
			},
			(error) => {
				this.showErrorMessage(ETVConstants.trans("error"),error.message);
			}
		)
	}

	restartDevice(deviceID, soft) {
		this.setState({aborted:false});
		this.showInfoMessageSpinning(ETVConstants.trans("restart"),ETVConstants.trans("sending_device_restart_request"));
		var softRestartParam = soft?"soft_restart":"reboot";
		const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({action: 'send_message',device_id:deviceID, fb_action:'app_restart',fb_param_0:softRestartParam })
		};
		fetch(ETVConstants.getServerBase()+'/firebase', requestOptions)
		.then(res => res.json())
		.then(
			(result) => {
					if(ETVConstants.ON_PREMISE_VERSION) {
						this.showSuccessMessage(ETVConstants.trans("restart"),"restart "+(soft?"application":"device")+" command was sent to device");
						return;
					}
					if(result['result']) {
						this.showInfoMessageSpinning(ETVConstants.trans("restart"),ETVConstants.trans("sending_device_restart_request"));
						this.setState({message_id:result.data.message_id, msg_count:0});
						setTimeout(()=>this.getRestartReplyStatus(), 1000);
					}else{
						this.showErrorMessage(ETVConstants.trans("error"),result.reason);
					}
			},
			(error) => {
				this.showErrorMessage(ETVConstants.trans("error"),'Error: '+error.message);
			}
		)
	}

	restartDeviceGroup(groupID, soft) {
		this.showInfoMessageSpinning(ETVConstants.trans("restart"),ETVConstants.trans("sending_device_restart_request"));
		var softRestartParam = soft?"soft_restart":"reboot";

		var deviceIDs = this.getDeviceIDsInGroup(groupID);
		for(var i=0; i<deviceIDs.length; i++) {
				var deviceID = deviceIDs[i];
				var isLast = (i===deviceIDs.length-1);
				//console.log("restarting deviceID="+deviceID);

				const requestOptions = {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({action: 'send_message',device_id:deviceID, fb_action:'app_restart',fb_param_0:softRestartParam })
				};
				fetch(ETVConstants.getServerBase()+'/firebase', requestOptions)
				.then(res => res.json())
				.then(
					(result) => {
						if(isLast) {
							this.showInfoMessageSpinning(ETVConstants.trans("restart"),ETVConstants.trans("device_restart_request_sent"));
						}
					},
					(error) => {
						this.showErrorMessage(ETVConstants.trans("error"),'Error: '+error.message);
					}
				)
		}
	}

	showEmergencyMessage(deviceID, isGroup) {
		this.showWindow("emergency_message_div",true);
		if(isGroup) {
			this.setState({selected_group_id:deviceID, selected_device_id:undefined});
		}else{
			this.setState({selected_group_id:undefined, selected_device_id:deviceID});
		}
	}

	getGroup(groupID) {
		for(var i=0; i<this.state.groups.length; i++) {
			if(this.state.groups[i].group_id===groupID) return this.state.groups[i];
		}
		return null;
	}

	getDeviceIDsInGroup( groupID) {
		var group = this.getGroup(groupID);
		return group.device_ids;
	}

	submitEmergencyMessageA() {
		if(this.state.selected_device_id) {
			this.submitEmergencyMessage(this.state.selected_device_id,true);
		}else if(this.state.selected_group_id) {
			var deviceIDs = this.getDeviceIDsInGroup(this.state.selected_group_id);
			for(var i=0; i<deviceIDs.length; i++) {
				this.submitEmergencyMessage(deviceIDs[i],i===deviceIDs.length-1);
			}
		}
	}

	submitEmergencyMessage(deviceID, showMessage) {
		//console.log("submit message to deviceID="+deviceID);
		const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({action: 'send_message',device_id:deviceID, fb_action:'emergency_message', fb_param_0:this.state.emergency_message })
		};
		fetch(ETVConstants.getServerBase()+'/firebase', requestOptions)
		.then(res => res.json())
		.then(
			(result) => {
					if(result['result']) {
						if(showMessage) {
							this.showSuccessMessage(ETVConstants.trans("emergency_message"),ETVConstants.trans("emergency_message_sent"));
						}
						this.setState({selected_device_id:undefined,selected_group_id:undefined});
					}else{
					}
			},
			(error) => {
			}
		)
	}

	stopEmergencyMessageA(deviceIDorGroupID, isGroup) {
		//console.log("deviceIDorGroup="+deviceIDorGroupID+" isGroup="+isGroup);
		if(!isGroup) {
			this.stopEmergencyMessage(deviceIDorGroupID,true);
		}else{
			var deviceIDs = this.getDeviceIDsInGroup(deviceIDorGroupID);
			for(var i=0; i<deviceIDs.length; i++) {
				this.stopEmergencyMessage(deviceIDs[i],i===deviceIDs.length-1);
			}
		}
	}

	stopEmergencyMessage(deviceID,showMessage) {
		//console.log("emergency message stopped on deviceID="+deviceID);
		const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({action: 'send_message',device_id:deviceID, fb_action:'emergency_message', fb_param_0:'' })
		};
		fetch(ETVConstants.getServerBase()+'/firebase', requestOptions)
		.then(res => res.json())
		.then(
			(result) => {
					if(result['result']) {
						this.showSuccessMessage(ETVConstants.trans("emergency_message"),ETVConstants.trans("emergency_message_removed"));
					}else{
					}
			},
			(error) => {
			}
		)
	}

	showMessageButtonOn(rowData) {
		if(this.isWebPlayer(rowData)) return <IconButton disabled><SpeakerNotesIcon/></IconButton>
		if (rowData.sw_version<44) return <span/>
		return <IconButton color='primary' onClick={()=>this.showEmergencyMessage(rowData.id,false)}><SpeakerNotesIcon/></IconButton>
	}

	showMessageButtonOnGroup(rowData) {
		if (rowData.sw_version<44) return <span/>
		return <IconButton color='primary' onClick={()=>this.showEmergencyMessage(rowData.group_id,true)}><SpeakerNotesIcon/></IconButton>
	}

	showMessageButtonOff(rowData) {
		if(this.isWebPlayer(rowData)) return <IconButton disabled><SpeakerNotesOffIcon/></IconButton>
		if (rowData.sw_version<44) return <span/>
		return <IconButton color='primary' onClick={()=>this.stopEmergencyMessageA(rowData.id,false)}><SpeakerNotesOffIcon/></IconButton>
	}

	showMessageButtonOffGroup(rowData) {
		if (rowData.sw_version<44) return <span/>
		return <IconButton color='primary' onClick={()=>this.stopEmergencyMessageA(rowData.group_id,true)}><SpeakerNotesOffIcon/></IconButton>
	}


	fileUpload( deviceID) {
		this.showWindow('file_upload_div',true)
		this.setState({selected_device_id: deviceID});
	}

	getLogs( deviceID) {
			const requestOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({action: 'send_message',device_id:deviceID, fb_action:'get_logs' })
			};
			fetch(ETVConstants.getServerBase()+'/firebase', requestOptions)
				.then(res => res.json())
				.then(
					(result) => {
						if(result['result']) {
							this.showInfoMessageSpinning(ETVConstants.trans("logs"),ETVConstants.trans("getting logs request"));
							this.setState({message_id:result.data.message_id, msg_count:0});
							if(!this.state.aborted) setTimeout(()=>this.getLogReplyStatus(), 1000);
						}else{
							this.showErrorMessage(ETVConstants.trans("error"),result.reason);
						}
					}
				)
	}

	openLog(deviceID,nr) {
		window.open('https://storage.googleapis.com/hotel-screen.appspot.com/'+deviceID+'/log/log_'+nr+'.txt',"_blank");
	}

    render() {

		if(!this.state.isLoaded) {
			return <ETVPage width="wide" icon={<SettingsRemoteOutlined fontSize="large"/>}
				title={ETVConstants.trans("remote_management") || "Remote management"}
				description="Monitor screens and perform remote device actions." loading/>;
		}
		
		var isSuperAdmin = this.props.status === "superadmin";

		const tableTitleScreenGroups = <Typography variant="h6">{ETVConstants.trans("groups")}</Typography>;
		var columnsDataScreenGroups= [
				{ title: ETVConstants.trans('group_name'), field: 'group_name', render: rowData => <Typography style={{fontWeight:600}} variant='body2'>{rowData.group_name}</Typography> },
				{ title: ETVConstants.trans("message_on"), field: '', render: rowData => this.showMessageButtonOnGroup(rowData)},
				{ title: ETVConstants.trans("message_off"), field: '', render: rowData => this.showMessageButtonOffGroup(rowData)},
				{ title: ETVConstants.trans("reboot"), field: '', render: rowData => <IconButton color='primary' onClick={()=>this.restartDeviceGroup(rowData.group_id,false)}><RotateLeftIcon/></IconButton>},
				{ title: ETVConstants.trans("restart_app"), field: '', render: rowData => <IconButton color='primary' onClick={()=>this.restartDeviceGroup(rowData.group_id,true)}><RotateLeftIcon/></IconButton>},
      	];

      	var columnsData= [];
		if (isSuperAdmin) {
			columnsData= [
				{ title: ETVConstants.trans("last_connect"), field: 'last_connected', render: rowData => (<div style={{width: "15px", maxWidth:"30px", paddingLeft: "3px"}}> {ETVConstants.getLastConnectSymbol(rowData.last_connected,rowData.startup_datetime,rowData.status)} </div>) },
				{ title: ETVConstants.trans("device_name"), field: 'device_name', render: rowData => (<div style={{minWidth: "200px", paddingLeft: "10px"}}> {rowData.device_name} </div>)  },
				{ title: ETVConstants.trans("location"), field: 'location_name'},
				{ title: ETVConstants.trans("message_on"), field: '', render: rowData => this.showMessageButtonOn(rowData)},
				{ title: ETVConstants.trans("message_off"), field: '', render: rowData => this.showMessageButtonOff(rowData)},
				{ title: ETVConstants.trans("reboot"), field: '', render: rowData => <IconButton variant='contained' color='primary' disabled={false} onClick={()=>this.restartDevice(rowData.id,false)}><RotateLeftIcon/></IconButton>},
				{ title: ETVConstants.trans("restart_app"), field: '', render: rowData => <IconButton variant='contained' color='primary' disabled={false} onClick={()=>this.restartDevice(rowData.id,true)}><RotateLeftIcon/></IconButton>},
				...(!ETVConstants.ON_PREMISE_VERSION ? [{ title: ETVConstants.trans("screen_shot"), field: 'screenshot', render: rowData => <IconButton variant='contained' color='primary' disabled={false} onClick={()=>this.screenShot(rowData.id, rowData.screen_ratio)}><ScreenShotIcon/></IconButton>}] : []),
				{ title: ETVConstants.trans('file_upload'), field: '', render: rowData => <IconButton variant='contained' color='primary' disabled={false} onClick={()=>this.fileUpload(rowData.id)}><UploadFileIcon/></IconButton>},
				{ title: ETVConstants.trans('get_logs'), field: '', render: rowData => <IconButton variant='contained' color='primary' disabled={false} onClick={()=>this.getLogs(rowData.id)}><StorageIcon/></IconButton>},
			];
		}else{
			if(!ETVConstants.ON_PREMISE_VERSION){
				columnsData= [
					{ title: ETVConstants.trans("last_connect"), field: 'last_connected', render: rowData => (<div style={{width: "15px", maxWidth:"30px", paddingLeft: "3px"}}> {ETVConstants.getLastConnectSymbol(rowData.last_connected,rowData.startup_datetime,rowData.status)} </div>) },
					{ title: ETVConstants.trans("device_name"), field: 'device_name', render: rowData => (<div style={{minWidth: "200px", paddingLeft: "10px"}}> {rowData.device_name} </div>)  },
					{ title: ETVConstants.trans("location"), field: 'location_name'},
					{ title: ETVConstants.trans("message_on"), field: '', render: rowData => this.showMessageButtonOn(rowData)},
					{ title: ETVConstants.trans("message_off"), field: '', render: rowData => this.showMessageButtonOff(rowData)},
					{ title: ETVConstants.trans("reboot"), field: '', render: rowData => <IconButton variant='contained' color='primary' disabled={ETVConstants.getLastConnectMins(rowData.last_connected)>=15} onClick={()=>this.restartDevice(rowData.id,false)}><RotateLeftIcon/></IconButton>},
					{ title: ETVConstants.trans("restart_app"), field: '', render: rowData => <IconButton variant='contained' color='primary' disabled={ETVConstants.getLastConnectMins(rowData.last_connected)>=15} onClick={()=>this.restartDevice(rowData.id,true)}><RotateLeftIcon/></IconButton>},
					{ title: ETVConstants.trans("screen_shot"), field: 'select_layout', render: rowData => <IconButton variant='contained' color='primary' disabled={ETVConstants.getLastConnectMins(rowData.last_connected)>=15} onClick={()=>this.screenShot(rowData.id, rowData.screen_ratio)}><ScreenShotIcon/></IconButton>},
				];
			}else{
				columnsData= [
					{ title: ETVConstants.trans("last_connect"), field: 'last_connected', render: rowData => (<div style={{width: "15px", maxWidth:"30px", paddingLeft: "3px"}}> {ETVConstants.getLastConnectSymbol(rowData.last_connected,rowData.startup_datetime,rowData.status)} </div>) },
					{ title: ETVConstants.trans("device_name"), field: 'device_name', render: rowData => (<div style={{minWidth: "200px", paddingLeft: "10px"}}> {rowData.device_name} </div>)  },
					{ title: ETVConstants.trans("location"), field: 'location_name'},
					{ title: ETVConstants.trans("message_on"), field: '', render: rowData => this.showMessageButtonOn(rowData)},
					{ title: ETVConstants.trans("message_off"), field: '', render: rowData => this.showMessageButtonOff(rowData)},
					{ title: ETVConstants.trans("reboot"), field: '', render: rowData => <IconButton variant='contained' color='primary' disabled={ETVConstants.getLastConnectMins(rowData.last_connected)>=15} onClick={()=>this.restartDevice(rowData.id,false)}><RotateLeftIcon/></IconButton>},
					{ title: ETVConstants.trans("restart_app"), field: '', render: rowData => <IconButton variant='contained' color='primary' disabled={ETVConstants.getLastConnectMins(rowData.last_connected)>=15} onClick={()=>this.restartDevice(rowData.id,true)}><RotateLeftIcon/></IconButton>},
				];
			}
		}
		columnsData = this.disableRemoteActionsForWebPlayers(columnsData);

      	const tabletitle = <Typography variant="h6">{ETVConstants.trans("screens")}</Typography>;

	  	return(
			<ETVPage width="wide" icon={<SettingsRemoteOutlined fontSize="large"/>}
				title={ETVConstants.trans("remote_management") || "Remote management"}
				description="Monitor screens and perform remote device actions.">
				{this.state.groups && this.state.groups.length>0?
					<div style={{width:'100%',maxWidth:700,marginBottom:24}}>
						<ETVTable data={this.state.groups} columns={columnsDataScreenGroups} title={tableTitleScreenGroups} pageSize={5} search={false} />
					</div>
					:
					<span/>
				}
				<div>
				<ETVTable data={[...this.state.items,...this.state.webPlayers]} columns={columnsData} title={tabletitle} pageSize={20} search />
			</div>

			<ETVPopup
				open={this.state.window==='screenshot_div'}
				width="standard"
				onClose={() => this.setState({window:'',aborted:true})}
				icon={<ScreenShotIcon />}
				title="Screenshot"
				contentSx={{overflowX:'hidden'}}
				bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.setState({window:'',aborted:true})}/>}
			>
						{!this.state.screenshot_url?<span/>:
						<Box 
								sx={{
								width:'100%',display:'flex',justifyContent:'center',p:2,
								boxSizing:'border-box',bgcolor:'grey.100',borderRadius:2,overflow:'hidden',
							}}							
						>
						<img
							alt="Screen screenshot"
							src={this.state.screenshot_url} 
							style={{
								maxWidth:'100%',maxHeight:'70vh',objectFit:'contain',borderRadius:8,
							}} />
						</Box>
						}
			</ETVPopup>

			<ETVMessagePopup open={this.state.window==='message_div'} onClose={()=>this.closeInfoMessage()} title={this.state.info_title} message={this.state.info_message} type={this.state.spinning?'progress':(this.state.info_type || 'info')} />

			<ETVPopup
				open={this.state.window==='emergency_message_div'}
				width="small"
				onClose={() => this.showWindow('emergency_message_div',false)}
				icon={<SpeakerNotesIcon />}
				title={ETVConstants.trans("emergency_message")}
				bottomActions={<><ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.showWindow('emergency_message_div',false)}/><ETVActionButton action="send" label={ETVConstants.trans("submit")} disabled={!this.state.emergency_message || this.state.emergency_message.trim().length===0} onClick={()=>this.submitEmergencyMessageA()}/></>}
			>
					<TextField multiline minRows={5} maxRows={5} variant="outlined" fullWidth label={ETVConstants.trans("emergency_message")} value={this.state.description} onChange={(e)=>{this.setState({emergency_message:e.target.value})}}/>
			</ETVPopup>

			<ETVPopup
				open={this.state.window==='file_upload_div'}
				onClose={()=>this.setState({window:''})}
				width="small"
				icon={<UploadFileIcon />}
				title={ETVConstants.trans("file_upload")}
				bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={()=>this.setState({window:''})}/>}
			>
					<FileUploadAdmin user_id={this.props.user_id} device_id={this.state.selected_device_id} />
			</ETVPopup>
	   	</ETVPage>
		);
	}
}

export default RemoteDeviceMgmt
